const BaseComponent = require('base/base-component');
const ESClient = require('helper/es-client');
const Spinner = require('helper/spin');

const listTpl = Handlebars.templates['guigang/comps/EsNoticeTabs/templates/list-tpl'];

class GuigangNoticeTabs extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .tab': 'switchTab'
      }
    });
  }
  init () {
    super.init();
    this.client = new ESClient();
    this.$more = this.$el.find('.to-more');
    this.$tabs = this.$el.find('.nav .tab');
    this.dataSource = new Array(this.$tabs.length);
    this.$countBox = this.$el.find('.purchase-count');
    this.$content = this.$el.find('.content');
    this.districtCode = JSON.parse(this.$el.find('[name="districtCode"]').val());
    // this.isAll = !(this.districtCode.length > 1);
    // 初始化 more href属性
    this.$tabs.eq(0).trigger('click');
    const now = new Date();
    const end = now.getTime();
    const begin = (new Date(now.getFullYear(), now.getMonth(), now.getDate())).getTime();
    // debugger;
    const d2 = this.client.searchArticleByKeyWord({ pageNo: 1, pageSize: 0, districtCode: this.districtCode, isAll: false });
    const d3 = this.client.searchArticle({ pageNo: 1, pageSize: 0, districtCode: this.districtCode, begin, end });
    $.when(d2, d3)
      .done(([data1], [data2]) => {
        this.$countBox.find('.newAdd').text(`${data2.hits.total}条`);
        this.$countBox.find('.totalItems').text(`${data1.hits.total}条`);
      });
  }
  switchTab (e) {
    const $target = $(e.currentTarget);
    // const total = $target.data('total');
    // const todayTotal = $target.data('today-total');
    const code = $target.data('code');
    const index = $target.index();
    $target.addClass('active')
      .siblings('.tab')
      .removeClass('active');

    // url切换
    this.$more.prop('href', `${$target.data('path')}?districtCode=${encodeURIComponent(this.districtCode)}`);

    // 列表查询(防止重复查询)
    if (this.dataSource[index]) {
      this.$content.html(listTpl({ _DATA_: this.dataSource[index].hits }));
      // 统计条数切换
      // this.$countBox.find('.newAdd').text(`${this.dataSource[index].todayTotal}条`);
      // this.$countBox.find('.totalItems').text(`${this.dataSource[index].total}条`);
    } else {
      // ES查询公告列表和今日新增条数
      const spinner = new Spinner({
        top: '45%'
      }).spin(this.$content[0]);
      let d1 = this.client.searchArticleByKeyWord({ code, pageNo: 1, pageSize: 8, districtCode: this.districtCode, isAll: false });
      d1
        .done((data1) => {
          this.dataSource[index] = data1.hits;
          const now = new Date().toDateString();
          // 遍历数据判断是否为新增
          this.dataSource[index].hits.map(({ _source }) => {
            _source.isNew = new Date(_source.publishDate).toDateString() === now;
            return _source;
          });
          this.$content.html(listTpl({ _DATA_: this.dataSource[index].hits }));
          // // 统计条数切换
          // this.$countBox.find('.newAdd').text(`${this.dataSource[index].todayTotal}条`);
          // this.$countBox.find('.totalItems').text(`${this.dataSource[index].total}条`);
        })
        .always(() => {
          spinner.stop();
        });
    }
  }
}
module.exports = GuigangNoticeTabs;
